export const drawerConfig = [
    {
        name: "Home",
        route: '/home'
    },
    {
        name: "Novos Treinamentos",
        route: "/journeys/new"
    },
    {
        name: "Treinamentos em Progresso",
        route: "/journeys/inprogress"
    },
    {
        name: "Treinamentos Completos",
        route: "/journeys/completed"
    },
    // {
    //     name: "Mural",
    //     route: "/mural"
    // },
	{
		name: "Perfil",
		route: "/profile"
	},
    // {
    //     name: 'Ranking',
    //     route: '/ranking'
    // },
    {
        name: 'Desempenho',
        route: '/performance'
    },
];
